import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { SBUModel, UserSBUInfoModel } from "../../models/SBUModel";
import SBUService from "../../services/SBUService";
import SBUSlice from "../slices/SBUSlice";
import { RootState } from "../store";

export const SBUActions = SBUSlice.actions;
export const fetchSBUs = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(SBUActions.setIsSbusFetching(true));
    const response: SBUModel[] = await SBUService.getAllSBUs();
    dispatch(SBUActions.setSBUs(response));
    dispatch(SBUActions.setIsSbusFetching(false));
  };
};
export const fetchParticularSBU = (
  SBU_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: SBUModel = await SBUService.getParticularSBU(SBU_id);
    dispatch(SBUActions.setParticularSBU(response));
  };
};

export const fetchUserSBUs = (
  userId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: UserSBUInfoModel[] = await SBUService.getAllUserSBUs(
      userId
    );
    dispatch(SBUActions.setUserSBUs(response));
  };
};

export const setParticularUserSBU = (
  data: UserSBUInfoModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(SBUActions.setParticularUserSBU(data));
  };
};

export const resetParticularUserSBU = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(SBUActions.resetParticularUserSBU());
  };
};
